import React, { useRef, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";

const Modal = ({ setIsModalClose }) => {
  const outside = useRef();
  const handleOutsideClick = (e) => {
    if (outside.current.contains(e.target)) {
      return;
    }
    setIsModalClose(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  return (
    <div className="w-full h-full bg-model fixed top-0 left-0 justify-center items-center z-40 ">
      <div
        ref={outside}
        className="  md:w-1/4 md:h-75 model-res bg-white md:rounded-lg p-4 md:relative modalCards"
      >
        <h3 className="text-center pb-4 mt-6 text-black md:mb-0 mb-0 md:text-2xl text-2xl ">
          يجب تسجيل الدخول لعرض المعلومات{" "}
        </h3>

        <div className="flex justify-center p-8">
          <button className="blue-bg border text-white rounded-lg p-2 w-32 focus:outline-none">
            <RouterLink to="/sign-in">سجل دخول</RouterLink>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
